import { render, staticRenderFns } from "./patientMedicationsRep.vue?vue&type=template&id=fd4ff138&"
import script from "./patientMedicationsRep.vue?vue&type=script&lang=js&"
export * from "./patientMedicationsRep.vue?vue&type=script&lang=js&"
import style0 from "./patientMedicationsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports